// @flow
import React from 'react';
import { ListFilterItem } from 'components/atoms/listFilterItem';
import { useViewport } from 'components/templates/viewportProvider';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  options: Array,
  activeFilters: Array,
  toggleFilter: (option: any) => void,
};

export const VenueFilter = (props: Props) => {
  const { isMobile } = useViewport();
  const { options, activeFilters = [], toggleFilter } = props;
  const width = options.length > 2 ? 'venue-small' : 'venue-large';
  const unique = [
    ...new Map(options.map(item => [item['venue'], item])).values(),
  ];
  return (
    <div className={isMobile ? 'venue-filters-mobile' : 'venue-filters'}>
      <span className={'filter-type'}>VENUE</span>
      <div className={'filter-content-options'}>
        {unique.map(venue => {
          return (
            <ListFilterItem
              key={venue.venueId}
              title={
                !isMobile && unique.length > 2
                  ? venue.slicedName
                  : venue.restaurant
              }
              isActive={activeFilters.indexOf(venue.venueId) > -1}
              onClick={() => toggleFilter(venue)}
              subTitle={
                !isMobile && unique.length > 2 ? venue.slicedCity : venue.city
              }
              classname={width}
            />
          );
        })}
      </div>
    </div>
  );
};
